import { Navigate } from "react-router";
import { canEditSurveys } from "@/lib/surveys/survey-service";
import { SurveyEditor } from "@/components/surveys/survey-editor";
import { useAdmin } from "../session";

export default function NewSurveyPage() {
  const auth = useAdmin();
  // Viewers can read surveys but not create one. (The server refuses too.)
  if (!canEditSurveys(auth.role)) return <Navigate to="/admin/surveys" replace />;
  return <SurveyEditor survey={null} canEdit />;
}
